import React from "react";
import { useHistory } from 'react-router-dom';
import { Menu, Dropdown } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { useGraphicStandMutation } from '../hooks';
import GraphicPacking from 'components/graphic-packing';
import GraphicStand from 'components/graphic-stand';
import Icons from 'components/icons';
import { EntityRemoveButton, Localize } from 'components/service';


const GraphicStandActionField = ({ graphicStand, graphicListId }) => {


    const history = useHistory();

    const {
        _setMutationGraphicStandDelete,
        loadingMutationGraphicStandDelete,
    } = useGraphicStandMutation.delete({ graphicStand, graphicListId });


    const menu = (
        <Menu
            items={ [
                {
                    label: <Localize>MENUS_DROP.Label_Edit</Localize>,
                    key: '1',
                    icon: <Icons.Edit />,
                    onClick: () => history.push(`${ GraphicPacking.Const.basePath }/${ graphicListId }${ GraphicStand.Const.basePath }/${ graphicStand.id }`)
                },
                {
                    key: '2',
                    icon:
                        <EntityRemoveButton
                            modalButton={
                                <span style={ { display: 'flex', alignItems: 'center' } } ><Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize></span>
                            }
                            nameEntity={ Localize({ children: "ENTITY.Modal_Title_Stand" }).props.children }
                            dataNameEntity={ graphicStand.exhibitor }
                            loading={ loadingMutationGraphicStandDelete }
                            deleteMutation={ _setMutationGraphicStandDelete }
                            variables={ {
                                id: graphicStand.id,
                            } }
                        />,
                },
            ] }
        />
    );

    return (
        <Dropdown
            // trigger={['click']}
            placement="bottomRight"
            overlay={ menu }
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    )
};

export default GraphicStandActionField;